import { render, staticRenderFns } from "./ReviewItemNew.vue?vue&type=template&id=503b4209&"
import script from "./ReviewItemNew.vue?vue&type=script&lang=js&"
export * from "./ReviewItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports